import {Button, Col, Drawer, Form, Input, Row, Typography} from "antd";
import React, {useEffect, useMemo, useState} from "react";
import {useBoxesUpdateBoxMutation} from "@mwServices/Boxes";
import {showResponse} from "@services/Api";
import useHasPermission from "@hooks/useHasPermission";
import {useWindowSize} from "@components/window-size-provider";

const { TextArea } = Input;

const BoxesEditDrawerContent = ({form, box, onClose}) => {
    const initForm = useMemo(() => ({
        ...box,
    }), [box]);
    const [callUpdateBox, updateBoxResponse] = useBoxesUpdateBoxMutation();
    const [nameExists, setNameExists] = useState(false);

    useEffect(() => {
        let isBoxNameError = false;
        let errorMessage = 'Failed to update the box.';
        if (!updateBoxResponse.isLoading && updateBoxResponse.data) {
            if (updateBoxResponse.data.success === 0) {
                if(updateBoxResponse.data.error === 'box_name_exists' ){
                    isBoxNameError = true;
                    setNameExists(true);
                    errorMessage = "Virtual Box name already exists, please choose another one.";
                }
            }

            showResponse(updateBoxResponse, 'Virtual Box updated', errorMessage);

            if(!isBoxNameError){
                form.resetFields();
                setNameExists(false);
                onClose();
            }
        }
    }, [updateBoxResponse]);

    const submitForm = async (values) => {
        let sanitisedData = {...values, artwork_id: box.artwork_id, box_id: box.id};
        await callUpdateBox(sanitisedData);
    };

    useEffect(() => {
        form.resetFields();
    }, [box]);

    return (
        <>
            <Row className="pad-bot-20">
                <Col span={24}>
                    <Typography>Boxes allow you to create subgroups of your main collection.</Typography>
                </Col>
            </Row>

            <Form
                labelCol={{span: 8}}
                initialValues={initForm}
                wrapperCol={{span: 16}}
                form={form}
                name="control-hooks"
                onFinish={submitForm}
            >
                <Row>
                    <Col span={4} className="align-left-top">
                    </Col>
                    <Col span={20}>
                        <Form.Item label="Box Title" labelAlign={"left"} name="name" validateStatus={nameExists ? "error" : ""} help={nameExists ? "A Virtual Box name already exists, please choose another one." : ""}>
                            <Input placeholder="Title" />
                        </Form.Item>

                        <Form.Item label="Description" labelAlign={"left"} name="description">
                            <TextArea rows={4} placeholder="Optional" maxLength={1000} showCount />
                        </Form.Item>
                    </Col>
                </Row>
        </Form>
        </>
    );
};

const BoxesEditDrawer = ({visible, box, onClose}) => {
    const [form] = Form.useForm();
    const windowDimensions = useWindowSize();
    const [drawerWidth, setDrawerWidth] = useState(450);
    const isAdmin = useHasPermission('admin');

    const onCloseExec = () => {
        form.resetFields();
        onClose();
    };

    useEffect(() => {
        const newWidth = (windowDimensions.width < 450) ? windowDimensions.width : 450;
        if(newWidth !== drawerWidth) setDrawerWidth(newWidth);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [windowDimensions]);

    return (
        <Drawer
            title="Edit Box"
            className={"issue-edit-drawer"}
            headerStyle={{paddingTop: isAdmin ? 50 : 16}}
            width={drawerWidth}
            placement="right"
            onClose={onCloseExec}
            open={visible}
            footer={
                <Row justify="center">
                    <Col >
                        <Button className="outlineButton thickButton width-250px" onClick={() => form.submit()}>Save Box</Button>
                    </Col>
                </Row>
            }
        >
            {visible && (
                <BoxesEditDrawerContent onClose={onCloseExec} form={form} box={box} />
            )}
        </Drawer>
    );
};

export default BoxesEditDrawer;